
















import { Component, Vue, Prop } from 'vue-property-decorator';
import { generateReceiptImage } from './draw';
import type { ReceiptData } from './types';

@Component
export default class extends Vue {
  @Prop({ default: () => [] })
  data!: ReceiptData;
  @Prop({ default: '' })
  templateUrl!: string;

  generateData = {};
  imageUrl = '';

  mounted() {
    this.generateData = this.data;
    this.generate();
  }

  async generate() {
    if (!this.$refs["canvas"]) return;
    this.imageUrl = await generateReceiptImage(
      this.$refs["canvas"],
      this.templateUrl,
      this.generateData
    );
  }

  download() {
    const a = document.createElement('a');
    a.href = this.imageUrl;
    a.download = 'receipt.png';
    a.click();
  }
}
